<template>
  <OptionInput
    type="radio"
    :value="inputValue"
    :modelValue="modelValue"
    :updateFn="updateValue"
    :hideInput="isTextInputActive"
    :option="option"
    class="option-input--text"
    @click="showTextInput"
  >
    <input
      v-if="isTextInputActive"
      ref="textInputRef"
      type="text"
      class="option-input__label option-input__label--text-input"
      :placeholder="option.placeholder"
      :value="textInputValue"
      @input="updateValue"
      @blur="hideTextInput"
    />
    <span v-else class="option-input__label">
      {{ inputValue }}
    </span>
  </OptionInput>
</template>

<script setup lang="ts">
import { computed, nextTick, ref } from 'vue'

import { QuestionnaireFormOption } from '@/models/onboarding.types'
import OptionInput from './OptionInput.vue'

const props = defineProps<{
  modelValue: string[]
  option: QuestionnaireFormOption
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string[]): void
}>()

const textInputValue = ref('')
const inputValue = computed(() => {
  return textInputValue.value || props.option.label
})

const textInputRef = ref<HTMLInputElement | null>(null)
const isTextInputActive = ref(false)

function updateValue(): void {
  const input = textInputRef.value
  if (!input) {
    return
  }

  textInputValue.value = input.value
  emit('update:modelValue', [inputValue.value])
}

async function showTextInput(): Promise<void> {
  isTextInputActive.value = true

  await nextTick()
  if (!textInputRef.value) {
    return
  }

  textInputRef.value.focus()
  updateValue()
}

function hideTextInput(): void {
  isTextInputActive.value = false
  updateValue()
}
</script>

<style lang="scss" scoped>
.option-input {
  &__label--text-input {
    width: 100%;
    font-size: inherit;
    font-weight: inherit;
    letter-spacing: inherit;
    color: inherit;
    background: transparent;
  }
}
</style>
